import { render, staticRenderFns } from "./dds.vue?vue&type=template&id=155b18e7&"
import script from "./dds.vue?vue&type=script&lang=js&"
export * from "./dds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports